import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('Pto/GetList', { params });
  },
  getDetail(_, id) {
    return axios.get('Pto/GetDetail', { params: { id } });
  },
  reject(_, id) {
    return axios.get('Pto/Reject', { params: { id } });
  },
  approve(_, id) {
    return axios.get('Pto/Approve', { params: { id } });
  },
};
